<div id="rastgeleCümle">
  <h3 class="yesil">Rastgele cümle
    <a id="tazele" href="/">
      <img id="rastgeleTazele" alt="rastgeleTazele" src="kaynak/don.png" data-src="kaynak/don.png" data-hover="kaynak/tazele.png" >
    </a>
  </h3>
  <p id="hikayemiz" class="latin gri"></p>
  <p id="cümlemiz" class="latin mavimsi" lang="de"> Die Krähe hat ein Stück Käse in ihrem Schnabel.  </p>

  <p class="yesil"> —

    <a class="gezinmeKüçük gezinme renkliNumara yuvarlak ortaBoy" href="/cumle/goster/106">&#8249;</a>

    <a id="cümleNumarası" href="/cumle/goster/107"><img src="/kaynak/de.svg"> </a>

    <a class="gezinmeKüçük gezinme renkliNumara yuvarlak ortaBoy" href="/">.</a>

  </p>
</div>
